import { render, staticRenderFns } from "./CeppIcon.vue?vue&type=template&id=bef2b334&scoped=true&"
import script from "./CeppIcon.vue?vue&type=script&lang=js&"
export * from "./CeppIcon.vue?vue&type=script&lang=js&"
import style0 from "./CeppIcon.vue?vue&type=style&index=0&id=bef2b334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef2b334",
  null
  
)

export default component.exports